module.exports = __webpack_public_path__ + "img/omerCounting2.0331318f.gif";